import React from 'react';
import classNames from 'classnames';
import './index.less.js';

var Label = function Label(props) {
  var title = props.title,
    isRequired = props.isRequired;
  var labelCls = classNames({
    'ti-form-item-label': true,
    'ti-form-item-label-required': isRequired
  });
  return /*#__PURE__*/React.createElement("label", {
    className: labelCls
  }, title);
};

export { Label as default };
